import React from 'react';
import { observer } from 'mobx-react';
import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Panel from '../../commons/Panel';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Votacao extends React.Component {
  componentWillMount() {
    UIStore.init('Votação dos Candidatos', null, null, false, () =>
      SelecaoStore.loadCandidatos()
    );
    SelecaoStore.loadCandidatos();
  }

  render() {
    let posicao = 1;
    let anterior = null;
    let candidatos = SelecaoStore.candidatos.map(c => {
      let novo = { ...c };
      if (novo.projecao !== anterior) {
        novo.posicao = posicao++;
        anterior = novo.projecao;
      }
      return novo;
    });
    return (
      <React.Fragment>
        <Panel
          title="Projeção de Votos"
          loadHistory={() =>
            EvolucaoStore.loadCandidatosProporcionais('projecao')
          }
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Posição</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Número</TableCell>
                <TableCell>Partido</TableCell>
                <TableCell numeric>Projeção</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {candidatos.map((c, i) => (
                <TableRow key={i}>
                  <TableCell>{c.posicao}</TableCell>
                  <TableCell>
                    {c.candidato ? c.candidato.nome : 'Legenda'}
                  </TableCell>
                  <TableCell>
                    {c.candidato ? c.candidato.numero : c.partido.numero}
                  </TableCell>
                  <TableCell>
                    <Chip
                      key={c.id}
                      label={c.partido.sigla}
                      style={{
                        backgroundColor: c.partido.cor,
                        fontWeight: 'bold',
                        color: 'white',
                      }}
                    />
                  </TableCell>
                  <TableCell numeric>{c.projecao.formatInteger()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Panel>
        <EvolucaoDialog
          title="Evolução do Candidato"
          opened={EvolucaoStore.candidatos != null}
          data={EvolucaoStore.candidatos}
          onOK={() => (EvolucaoStore.candidatos = null)}
        />
      </React.Fragment>
    );
  }
}

export default observer(Votacao);



// WEBPACK FOOTER //
// ./src/components/proporcional/votacao/index.js